import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeforeBottomViewDirective } from '@directives/before-bottom-view/before-bottom-view.directive';
import { DoubleClickDirective } from './double-click/double-click.directive';
import { SwipeListenerDirective } from './swipe-listener/swipe-listener.directive';
import { RippleEffectDirective } from './ripple-effect/ripple-effect.directive';
import { LoadingEffectDirective } from './loading-effect/loading-effect.directive';
import { PinchZoomDirective } from './imagePinchZoom/pinch-zoom.directive';
import { ExperimentButtonDirective } from '@directives/experiment-button/experiment-button.directive';
import { ElementTrackableDirective } from '@directives/element-trackable/element-trackable.directive';
import { ElementInViewportDirective } from './element-in-viewport/element-in-viewport.directive';
import { KeyboardVisibilityDirective } from './keyboard-visibility/keyboard-visibility.directive';
import { ShopFirstRenderMarkerDirective } from './shop-first-render-marker/shop-first-render-marker.directive';
import { TrackScrollDepthDirective } from './track-scroll-depth/track-scroll-depth.directive';

@NgModule({
  imports: [CommonModule, ElementInViewportDirective, ShopFirstRenderMarkerDirective, TrackScrollDepthDirective],
  declarations: [
    DoubleClickDirective,
    SwipeListenerDirective,
    RippleEffectDirective,
    LoadingEffectDirective,
    BeforeBottomViewDirective,
    PinchZoomDirective,
    ElementTrackableDirective,
    ExperimentButtonDirective,
    KeyboardVisibilityDirective,
  ],
  exports: [
    DoubleClickDirective,
    SwipeListenerDirective,
    RippleEffectDirective,
    LoadingEffectDirective,
    BeforeBottomViewDirective,
    PinchZoomDirective,
    ElementTrackableDirective,
    ElementInViewportDirective,
    ExperimentButtonDirective,
    KeyboardVisibilityDirective,
    ShopFirstRenderMarkerDirective,
    TrackScrollDepthDirective,
  ],
})

export class DirectivesModule {}
